import React, { Component } from "react";
import Img from "gatsby-image";

export default class Clients extends Component {
  constructor(props) {
    super(props);
    this.handleScroll = this.handleScroll.bind(this);
    this.state = { itemScroll: 0, opacity: 0 };
  }

  componentDidMount() {
    typeof window !== "undefined" &&
      window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll(event) {
    const clamp = (min, max, val) => Math.min(Math.max(min, val), max);

    const { top, height } = this.clients.getBoundingClientRect();

    const val = clamp(0, 1, (-top + height) / (height * 3));
    const opa = (-top + height / 2) / (height * 0.8) > 0 ? 1 : 0;

    this.setState({
      itemScroll: window.innerWidth > 736 ? val : this.state.itemScroll,
      opacity: this.state.opacity == 1 ? 1 : opa
    });
  }

  render() {
    return (
      <section className="clients" ref={n => (this.clients = n)}>
        <div className="container">
          <div className="clients--wrap">
            <div className="clients--logos">
              <div className="clients--logo">
                <Img
                  resolutions={
                    this.props.images.pccomponentes.childImageSharp.resolutions
                  }
                  width="175"
                  height="55"
                  alt="PcComponentes"
                  className="vertical-logo img-responsive"
                />
              </div>
              <div className="clients--logo">
                <Img
                  resolutions={
                    this.props.images.alchemist.childImageSharp.resolutions
                  }
                  width="175"
                  height="55"
                  alt="The Alchemist Atelier"
                  className="vertical-logo img-responsive"
                />
              </div>
              <div className="clients--logo">
                <Img
                  resolutions={
                    this.props.images.clubvillamar.childImageSharp.resolutions
                  }
                  width="175"
                  height="55"
                  alt="Club Villamar"
                  className="vertical-logo img-responsive"
                />
              </div>
              <div className="clients--logo">
                <Img
                  resolutions={
                    this.props.images.dietopro.childImageSharp.resolutions
                  }
                  width="175"
                  height="55"
                  alt="Dietopro"
                  className="vertical-logo img-responsive"
                />
              </div>
              <div className="clients--logo">
                <Img
                  resolutions={
                    this.props.images.aulaplus.childImageSharp.resolutions
                  }
                  width="175"
                  height="55"
                  alt="Aulaplus"
                  className="vertical-logo img-responsive"
                />
              </div>
              <div className="clients--logo">
                <Img
                  resolutions={
                    this.props.images.pandemicquiz.childImageSharp.resolutions
                  }
                  width="175"
                  height="55"
                  alt="PandemicQuiz"
                  className="vertical-logo img-responsive"
                />
              </div>
              <div className="clients--logo">
                <Img
                  resolutions={
                    this.props.images.tiptoc.childImageSharp.resolutions
                  }
                  width="175"
                  height="55"
                  alt="Tiptoc"
                  className="vertical-logo img-responsive"
                />
              </div>
              <div className="clients--logo">
                <Img
                  resolutions={
                    this.props.images.miequipo.childImageSharp.resolutions
                  }
                  width="175"
                  height="55"
                  alt="Miequipodedietistas"
                  className="vertical-logo img-responsive"
                />
              </div>
              <div className="clients--logo">
                <Img
                  resolutions={
                    this.props.images.trecetas.childImageSharp.resolutions
                  }
                  width="175"
                  height="55"
                  alt="Trecetas"
                  className="vertical-logo img-responsive"
                />
              </div>
              <div className="clients--logo">
                <Img
                  resolutions={
                    this.props.images.iukanet.childImageSharp.resolutions
                  }
                  width="175"
                  height="55"
                  alt="Iukanet"
                  className="vertical-logo img-responsive"
                />
              </div>
              <div className="clients--logo">
                <Img
                  resolutions={
                    this.props.images.dpool.childImageSharp.resolutions
                  }
                  width="175"
                  height="55"
                  alt="Dpool"
                  className="vertical-logo img-responsive"
                />
              </div>
              <div className="clients--logo">
                <Img
                  resolutions={
                    this.props.images.interacso.childImageSharp.resolutions
                  }
                  width="175"
                  height="55"
                  alt="Interacso"
                  className="vertical-logo img-responsive"
                />
              </div>
              <div className="clients--logo">
                <Img
                  resolutions={
                    this.props.images.ultreia.childImageSharp.resolutions
                  }
                  width="175"
                  height="55"
                  alt="Ultreia"
                  className="vertical-logo img-responsive"
                />
              </div>
              <div className="clients--logo">
                <Img
                  resolutions={
                    this.props.images.leyelectoral.childImageSharp.resolutions
                  }
                  width="175"
                  height="55"
                  alt="Leyelectoral"
                  className="vertical-logo img-responsive"
                />
              </div>
              <div className="clients--logo">
                <Img
                  resolutions={
                    this.props.images.makoondi.childImageSharp.resolutions
                  }
                  width="175"
                  height="55"
                  alt="Makoondi"
                  className="vertical-logo img-responsive"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/organisms/Clients.js